import { render } from "./edit-topic.vue?vue&type=template&id=0b29d75a"
import script from "./edit-topic.vue?vue&type=script&lang=js"
export * from "./edit-topic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__